var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgG1Transceiver(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M64 38c0 8.25-3.66 16.2-10.31 22.36l-2.72-2.93C56.74 52 60 45.12 60 38c0-7.12-3.21-14-9-19.43l2.72-2.93C60.29 21.79 64 29.74 64 38zM48.44 21.52l-2.9 2.76A19.75 19.75 0 0151.32 38a19.75 19.75 0 01-5.78 13.7l2.9 2.76A23.68 23.68 0 0055.32 38a23.68 23.68 0 00-6.88-16.48zM38 10a2 2 0 00-2 2v52a2 2 0 004 0V12a2 2 0 00-2-2zm-17.32 5.63L18 18.56C23.78 24 27 30.86 27 38c0 7.14-3.21 14-9 19.43l2.72 2.93C27.33 54.19 31 46.24 31 38s-3.67-16.21-10.32-22.37zm-5.2 5.89l-2.9 2.76A19.75 19.75 0 0118.36 38a19.75 19.75 0 01-5.78 13.7l2.9 2.76A23.68 23.68 0 0022.36 38a23.68 23.68 0 00-6.88-16.48z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/G1_Transceiver.b5e5ddbf.svg";
export { SvgG1Transceiver as ReactComponent };